'use strict'

let self

export default self = {
  //overlay : document.querySelector('.gallery-overlay'),
  container : document.querySelector('#listing-detail .gallery-wrapper'),
  //gallery_top : document.querySelector('.gallery-top'),
  //gallery_bottom : document.querySelector('.gallery-thumbs'),
  animBox : {
	  mode: '',
  },
  galleryBox : document.querySelector('.gallery-box'),
  imageBox : document.querySelector('.gallery'),
  speed : 30,

  init : () => {
	  
    //self.btnClose = self.overlay.querySelector('.btn-close')
    //self.img = self.container.querySelector('img')
    self.triggers = [...document.querySelectorAll('[data-gallery-overlay-trigger]')]
	console.log('self.triggers: ' + self.triggers.length)
    //self.btnClose.addEventListener('click', self.toggle)
    self.triggers.forEach( trigger => trigger.addEventListener('click', self.toggle) )
  },

  toggle : e => {
    const button = e.currentTarget
    const parent = button.parentNode
    if (self.animBox.mode != 'expanding') {
	    self.animBox.mode = 'expanding';
	 	self.galleryRect = self.galleryBox.getBoundingClientRect();
	 	self.container.style.minHeight = self.galleryRect.height+'px';
	 	self.container.classList.add('fullscreen');
	 	self.animBox.left = self.galleryRect.left;
	 	self.animBox.top = Math.abs(self.galleryRect.top);
	 	self.animBox.topDir = '+';
	 	if (self.galleryRect.top < 0) self.animBox.topDir = '-';
	 	self.imageBox.style.marginTop = self.galleryRect.top+'px';
	 	self.imageBox.style.marginLeft = self.galleryRect.left+'px';
	 	self.imageBox.style.marginRight = self.galleryRect.left+'px';
	 	
	 	setInterval(function() {
		 	var mh = (parseInt(self.imageBox.style.marginLeft) - (self.animBox.left / self.speed));
		 	if (mh > 0) {
				self.imageBox.style.marginLeft = mh + 'px';
				self.imageBox.style.marginRight = mh + 'px';
			} else {
				self.imageBox.style.marginLeft = 0;
				self.imageBox.style.marginRight = 0;
				window.dispatchEvent(new Event('resize'));
			}
			if (self.animBox.topDir == '+') {
				var mv = (parseInt(self.imageBox.style.marginTop) - (self.animBox.top / self.speed));
				if (mv > 0) {
					self.imageBox.style.marginTop = mv + 'px';
				} else {
					self.imageBox.style.marginTop = 0;
				}
			} else {
				var mv = (parseInt(self.imageBox.style.marginTop) + (self.animBox.top / self.speed));
				if (mv < 0) {
					self.imageBox.style.marginTop = mv + 'px';
				} else {
					self.imageBox.style.marginTop = 0;
				}
			}
	 	}, 20);

    } else {
	    self.animBox.mode = 'reducing';
	    self.imageBox.style.margin = 0;
	    self.container.classList.remove('fullscreen');
    }
    
    
    
    
    //const isShown = ( self.container.classList.contains('fullscreen')  ? true : false)
    //console.log('Toggle!');
    //console.log('shown? ' + isShown);
    //self.container.classList.toggle('fullscreen')
  }
}